import React, { useEffect, useRef, useState } from 'react';
import whiteLoader from "../assets/gifs/white.gif";
import blackLoader from "../assets/gifs/short-black.gif";

export default function PageWithLoader({ children }) {
  const [isReady, setIsReady] = useState(false);
  const wrapperRef = useRef();

    useEffect(() => {
        const waitForFonts = document.fonts?.ready ?? Promise.resolve();
      
        const waitForImages = () => {
          const images = wrapperRef.current?.querySelectorAll('img') || [];
          const promises = Array.from(images).map(
            (img) =>
              new Promise((resolve) => {
                if (img.complete && img.naturalHeight !== 0) {
                  resolve();
                } else {
                  img.onload = img.onerror = resolve;
                }
              })
          );
          return Promise.all(promises);
        };
      
        const minDelay = new Promise((resolve) => setTimeout(resolve, 2000)); // full loader animation cycle
      
        Promise.all([waitForFonts, waitForImages(), minDelay]).then(() => {
          requestAnimationFrame(() => setIsReady(true));
        });
      }, []);

  if (!isReady) {
    return (
        <div
          style={{
            margin: 0,
            position: "absolute",
            top: "40%",
            left: "40%",
          }}
        >
          <img
            className="logoGif loaderDark"
            src={whiteLoader}
            alt="loading"
            style={{ maxWidth: "250px" }}
          />
          <img
            className="logoGif loaderLight"
            src={blackLoader}
            alt="loading"
            style={{ maxWidth: "250px" }}
          />
        </div>
      );
  }

  return <div ref={wrapperRef}>{children}</div>;
}
